import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Event from './pages/event';
import Error from './pages/error';
import Booking from './pages/booking';
import Onboarding from './pages/onboarding';
import Login from './pages/login';
import Splash from './pages/splash';
import Ticket from './pages/ticket';

import Map from './pages/map';
import Notifications from './pages/notifications';
function Paths() {
    return (

    <BrowserRouter>
    <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/home" element={<Home />} />
        <Route path="/exhibitiondetails" element={<Event />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/ticket" element={<Ticket />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/map" element={<Map />} />



        <Route path="*" element={<Error />} />

    </Routes>
    </BrowserRouter>
    );
}
 
export default Paths;